import { render, staticRenderFns } from "./JumpToPageDropdown.vue?vue&type=template&id=2ae37d9b"
import script from "./JumpToPageDropdown.vue?vue&type=script&lang=js"
export * from "./JumpToPageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports